export default "__VITE_ASSET__D9Mjr5Qf__"